var _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFonedoscop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2903_109002)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5882 39.0568C38.9634 44.8577 34.8137 49.4897 30.3849 51.9098C25.9909 54.311 21.3154 54.5441 16.5098 51.5412C11.7042 48.5383 9.86404 44.2339 10.096 39.2319C10.3298 34.1904 12.6739 28.4302 16.2987 22.6293C19.9003 16.8655 24.6502 12.6055 29.3952 10.3642C34.146 8.12015 38.8235 7.9244 42.377 10.1449C45.9306 12.3654 47.8051 16.6553 47.8708 21.909C47.9365 27.1564 46.1898 33.293 42.5882 39.0568Z",
    fill: "url(#paint0_radial_2903_109002)",
    stroke: "#CACACA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.5588,
    cy: 17.8551,
    rx: 11.728,
    ry: 10.398,
    transform: "rotate(32 37.5588 17.8551)",
    fill: "url(#paint1_linear_2903_109002)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.2424,
    cy: 16.7614,
    rx: 11.728,
    ry: 10.398,
    transform: "rotate(32 38.2424 16.7614)",
    fill: "#31312D"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.2078,
    cy: 16.7401,
    rx: 9.67254,
    ry: 8.70529,
    transform: "rotate(32 38.2078 16.7401)",
    fill: "url(#paint2_radial_2903_109002)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.59908,
    cy: 1.37038,
    rx: 1.59908,
    ry: 1.37038,
    transform: "matrix(-0.825909 -0.563803 -0.563803 0.825909 38.5684 15.4478)",
    fill: "url(#paint3_radial_2903_109002)",
    fillOpacity: 0.5
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.59908,
    cy: 1.37038,
    rx: 1.59908,
    ry: 1.37038,
    transform: "matrix(-0.825909 -0.563803 -0.563803 0.825909 42.1914 17.6709)",
    fill: "url(#paint4_radial_2903_109002)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.2078,
    cy: 16.7401,
    rx: 9.67254,
    ry: 8.70529,
    transform: "rotate(32 38.2078 16.7401)",
    fill: "#AC9B87"
  }))), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.4422,
    cy: 16.0115,
    rx: 0.768214,
    ry: 1.28967,
    transform: "rotate(54.1278 23.4422 16.0115)",
    fill: "url(#paint5_radial_2903_109002)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.768214,
    cy: 1.28967,
    rx: 0.768214,
    ry: 1.28967,
    transform: "matrix(-0.985192 -0.171451 -0.171451 0.985192 45.7178 28.4663)",
    fill: "url(#paint6_radial_2903_109002)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.1153,
    cy: 31.6533,
    rx: 1.0486,
    ry: 1.28967,
    transform: "rotate(54.1278 15.1153 31.6533)",
    fill: "#D9D9D9"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.1153,
    cy: 31.6533,
    rx: 1.0486,
    ry: 1.28967,
    transform: "rotate(54.1278 15.1153 31.6533)",
    fill: "url(#paint7_radial_2903_109002)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.0486,
    cy: 1.28967,
    rx: 1.0486,
    ry: 1.28967,
    transform: "matrix(-0.985192 -0.171451 -0.171451 0.985192 37.3721 42.7358)",
    fill: "#D9D9D9"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.0486,
    cy: 1.28967,
    rx: 1.0486,
    ry: 1.28967,
    transform: "matrix(-0.985192 -0.171451 -0.171451 0.985192 37.3721 42.7358)",
    fill: "url(#paint8_radial_2903_109002)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2903_109002",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.8477 25.319) rotate(122) scale(31.3955 30.7946)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2903_109002",
    x1: 25.8309,
    y1: 17.8551,
    x2: 49.0047,
    y2: 20.5957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0A0A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2903_109002",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2078 16.7401) rotate(90) scale(8.70529 9.67254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.325865,
    stopColor: "#CDCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410329,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842034,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.926498,
    stopColor: "#FBFBFB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2903_109002",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.62086 1.39372) rotate(-74.0095) scale(1.53466 1.79544)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2903_109002",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.62086 1.39372) rotate(-74.0095) scale(1.53466 1.79544)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2903_109002",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.7187 17.5165) rotate(-93.4609) scale(3.14796 1.87514)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2903_109002",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.0447 2.7947) rotate(-93.4609) scale(3.14797 1.87514)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2903_109002",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.4927 33.1583) rotate(-94.7191) scale(3.15291 2.55551)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2903_109002",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.426 2.7947) rotate(-94.7191) scale(3.15291 2.55551)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2903_109002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFonedoscop);
export default __webpack_public_path__ + "static/media/fonedoscop.10cd9c227101e326f63ff983d6294517.svg";
export { ForwardRef as ReactComponent };